import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Logo from '../Assist/hloylogo.png';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;
const navItems = ['Home', 'Our Courses', 'Why learn German?', 'Get Admission', 'Gallery', 'About Us', 'Contact Us'];

function Navbar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }} className=''>
      <Typography variant="h6" sx={{ my: 2, display: { sm: 'none', xs: 'block' }, fontFamily: 'Roboto Slab, serif' }}>
      <div  className='flexs flex-column text-center align-items-center  justify-content-center '>
              <img src={Logo} alt="Holy Institute logo" width={60} />
              <p style={{ fontSize: '10px', fontFamily: 'Roboto Slab, serif'  }} className='my-2'>Holy Institute</p>
            </div>      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <div>
          <ListItem key={item} disablePadding >
            <ListItemButton sx={{ textAlign: 'center',fontFamily:'"Roboto Slab", serif',color:'rgb(12, 12, 95)'}}  onClick={() => navigate(`/${item}`)}>
              <ListItemText primary={item} />
              
            </ListItemButton>

          </ListItem>
          <div className="w-100 border"></div>

          </div>
        ))}
      </List>
      <Footer color={'white'} />
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box className='flexs' position={'sticky'} sx={{ marginBottom: '110px',zIndex:'2' }}>
      <CssBaseline />
      <AppBar component="nav">
        <Toolbar className='Navbarbg flexs justify-content-space-around'>
          <div className=' w-100 m-0 flexs justify-content-space-aroud gap-5 align-items-center'>
          <Typography
          color="inherit"
          aria-label="open drawer"
          edge="start"
          className='col-7'
          sx={{ mr: 2, display: { sm: 'none' } }}>
                   <div className='flexs flex-row text-center align-items-center  justify-content-center  'style={{marginLeft:'10px'}} 
          >
              <img src={Logo} alt="Holy Institute logo" width={40} />
              <p style={{ fontSize: '20px'}} className='my-2 mx-1'>Holy Institute</p>
            </div> 
          </Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            className='col-4'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none'} }}
          >
         
           <MenuIcon/>   
          </IconButton>
          </div>
                
          <Typography
            variant="h6"
            className='col-3'
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            <div className=' align-items-center my-1 justify-content-center '>
              <img src={Logo} alt="Holy Institute logo" width={60} />
              <p style={{ fontSize: '10px', fontFamily: 'Roboto Slab, serif'  }} className='my-2'>Holy Institute</p>
            </div>
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }} className='justify-content-space-around col-9'>
            {navItems.map((item) => (
              <Button key={item}  onClick={() => navigate(`/${item}`)} className='mx-1 text-bold hovernavlink' sx={{ color: '#fff', fontFamily: 'Roboto Slab, serif' }}>
                {item} <h3 className='mx-2 text-white'>|</h3>
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
